<template>
  <Summary
      :heading="setting.header"
      heading-icon="cipPicture"
      :palette="setting.palette"
      :tooltip="setting.tooltip"
      :heading-value="heading"
      :rows="rows"
  />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Filters from "@/domain/core/utils/filters";
import {Settings} from "@/domain/stats/settings";
import Summary from "@/domain/stats/components/Summary.vue";
import MessageManager from "@/domain/core/utils/messageManager";
import mqttTopics from "@/domain/core/constant/mqttTopics";

export default {
  name: "MediaSummary",
  components: {Summary},
  async mounted() {
    await this.fetchSummaryMedia()
    MessageManager.on(mqttTopics.upload.pica_service, (data) => {
      this.updateMediaSummary(data.metrics)
    }, 'media-summary-upload-pica-service')
    MessageManager.on(mqttTopics.stats.delivered, (data) => {
      this.updateMediaSummary(data.metrics)
    }, 'media-summary-upload-pica-service')
  },
  beforeDestroy() {
      MessageManager.off('media-summary-upload-pica-service')
  },
  computed: {
    ...mapGetters('nStats', [
      'mediaSummary',
      'picaServiceId'
    ]),
    setting() {
      return Settings.summary.media
    },
    heading() {
      if (!this.mediaSummary) return
      return Filters.number(this.mediaSummary.received)
    },
    rows() {
      if (this.mediaSummary === null)
        return []
      let num_per_user = 0
      if (this.mediaSummary.participants > 0)
        num_per_user = this.mediaSummary.delivered / this.mediaSummary.participants
      return [
        {
          title: this.setting.per_user.title,
          tooltip: this.setting.per_user.tooltip,
          value: Filters.number(num_per_user)
        },
      ]
    },
  },
  methods: {
    ...mapActions('nStats', [
      'fetchSummaryMedia',
      'updateMediaSummary'
    ]),
  }
}
</script>
